import { render, staticRenderFns } from "./LeadsChart.vue?vue&type=template&id=e1b724ea&"
import script from "./LeadsChart.vue?vue&type=script&lang=js&"
export * from "./LeadsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b724ea')) {
      api.createRecord('e1b724ea', component.options)
    } else {
      api.reload('e1b724ea', component.options)
    }
    module.hot.accept("./LeadsChart.vue?vue&type=template&id=e1b724ea&", function () {
      api.rerender('e1b724ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/LeadsChart.vue"
export default component.exports